import React, {MouseEvent, useEffect, useMemo, useState} from "react";
import Grid from "@mui/material/Grid";
import BasicTable from "../../components/tables/BasicTable";
import {ColumnDef, ColumnFiltersState} from "@tanstack/react-table";
import {useAppDispatch, useAppSelector} from "../../reducers/hooks";
import {Trash} from "iconsax-react";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import AlertExampleElementDelete from "../../sections/modals/exampleElementModal/AlertExampleElementDelete";
import ElementModalGeneric from "sections/modals/exampleElementModal/ElementModalGeneric";
import {FormattedMessage, useIntl} from "react-intl";
import {deleteElement, getAllElement, MunicipalityElement} from "reducers/Municipality/MunicipalityReducer";
import {openSnackbar, SnackbarState} from "../../reducers/snackbar/snackbarReducer";
import {MunicipalityElementForm} from "../../sections/forms/Municipality/MunicipalityElementForm";


export default function Municipality() {
    const dispatch = useAppDispatch();
    const intl = useIntl();
    const data = useAppSelector(state => state.municipalityElement.elements);
    const [open, setOpen] = useState<boolean>(false);
    const [selectedElement, setSelectedElement] = useState<MunicipalityElement | null>(null);
    const [selectedDeleteElement, setSelectedDeleteElement] = useState<any>();
    const [deleteAlertOpen, setDeleteAlertOpen] = useState<boolean>(false);

    // Stati di ricerca per ogni colonna
    const [searchTerms, setSearchTerms] = useState({
        name: "",
        province: "",
        postalCode: "",
    })

    // Funzione per gestire la modifica dei campi di ricerca
    const handleSearchChange = (key: string, value: string) => {
        setSearchTerms(prev => ({
            ...prev,
            [key]: value,
        }));
    };


    const columns = useMemo<ColumnDef<MunicipalityElement>[]>(() => [
        {
            header: intl.formatMessage({id: "Name"}),
            accessorKey: 'name',
        },
        {
            header: intl.formatMessage({id: "province"}),
            accessorKey: 'province',
        },
        {
            header: intl.formatMessage({id: "postalCode"}),
            accessorKey: 'postalCode',
        },
        {
            header: () => <FormattedMessage id="Actions" defaultMessage="Actions"/>,
            enableColumnFilter: false,
            accessorKey: 'Actions',
            meta: {
                className: 'cell-right',
            },
            disableSortBy: true,
            cell: ({row}) => (
                <Stack direction="row" alignItems="center" justifyContent="center" spacing={0}>
                    {/*<Tooltip title={<FormattedMessage id="edit" defaultMessage="edit"/>}>
                        <IconButton
                            color="primary"
                            onClick={(e: MouseEvent<HTMLButtonElement>) => {
                                e.stopPropagation();
                                setSelectedElement(row.original);
                                setOpen(true);
                            }}
                        >
                            <Edit/>
                        </IconButton>
                    </Tooltip>*/}
                    <Tooltip title={<FormattedMessage id="Delete" defaultMessage="Delete"/>}>
                        <IconButton
                            color="error"
                            onClick={(e: MouseEvent<HTMLButtonElement>) => {
                                e.stopPropagation();
                                setSelectedDeleteElement(row.original);
                                setDeleteAlertOpen(true);
                            }}
                        >
                            <Trash/>
                        </IconButton>
                    </Tooltip>
                </Stack>
            ),
        },
    ], [searchTerms]);

    useEffect(() => {
        dispatch(getAllElement())
    }, []);

    const handleModalOpen = (open: boolean) => {
        setOpen(open)
        setSelectedElement(null)
    }
    const handleDelete = (_id: string) => {
        dispatch(deleteElement({_id: _id, callback: onDeleteSuccess}));
    }

    const refreshData = () => {
        //effettuare la dispatch della getAll e della visualizzazione popup
        dispatch(getAllElement())

    };

    const onDeleteSuccess = () => {
        //effettuare la dispatch della getAll e della visualizzazione popup
        dispatch(getAllElement())

        openSnackbar(
            {
                open: true,
                message: 'Element deleted successfully',
                variant: 'alert',
                alert: {
                    color: 'success'
                }
            } as SnackbarState
        )
    };

    const {formatMessage} = useIntl();
    const getTableTitle = () => {
        return formatMessage({id: "MunicipalityTitle", defaultMessage: "Municipality"});
    };

    return (
        <Grid container>
            <Grid item xs={12}>
                <BasicTable
                    columns={columns} data={data}
                    title={getTableTitle()}
                    striped
                    modalToggler={() => handleModalOpen(!open)}
                    onFilterChange={(values: ColumnFiltersState) => console.log(values)}
                    manualFiltering={false}/>
                <ElementModalGeneric
                    open={open}
                    setOpen={handleModalOpen}
                    element={selectedElement}
                    FormComponent={MunicipalityElementForm}
                    onSuccess={refreshData}

                />
                {selectedDeleteElement &&
                    <AlertExampleElementDelete
                        id={selectedDeleteElement._id}
                        title={"\n se il comune è collegato a dei cani, l'eliminazione non avverrà"}
                        open={deleteAlertOpen} handleClose={() =>
                        setDeleteAlertOpen(false)} onDelete={(_id) => handleDelete(_id)}/>}
            </Grid>
        </Grid>
    )
}
